/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_DaysInputs */

const en_us2_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training days`)
};

const pt_br2_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias de treino`)
};

const es_419_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días de entrenamiento`)
};

const pt_pt2_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias de treino`)
};

const fr_fr2_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours d'entraînement`)
};

const de_de2_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingstage`)
};

const it_it2_search_field_days = /** @type {(inputs: Search_Field_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni di allenamento`)
};

/**
* | output |
* | --- |
* | "Training days" |
*
* @param {Search_Field_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_days = /** @type {((inputs?: Search_Field_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_days(inputs)
	if (locale === "es-419") return es_419_search_field_days(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_days(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_days(inputs)
	if (locale === "de-DE") return de_de2_search_field_days(inputs)
	if (locale === "it-IT") return it_it2_search_field_days(inputs)
	return en_us2_search_field_days(inputs)
});
export { search_field_days as "search.field_days" }